<nz-form-control
  *ngIf="recordProperty !== undefined"
  class="ant-input-affix-wrapper-textarea-with-clear-btn"
>
  <div
    *ngIf="!recordProperty.ReadOnly"
    [ngxSummernote]="config"
    [ngxSummernoteView]="recordProperty.ValueAsObject"
    (ngModelChange)="valueChanged()"
    [class]="parentClass"
    [(summernoteModel)]="recordProperty.ValueAsObject"
  ></div>
  <div *ngIf="recordProperty.ReadOnly">
    <textarea nz-input readonly disabled>
      {{ recordProperty.ValueAsObject }}
    </textarea>
  </div>
</nz-form-control>
